export enum RechargeRecordTabType {
  Normal = "Normal",
  Coupon = "Coupon",
  FreeCoupon = "FreeCoupon",
  Member = "Member",
  Desktop = "Desktop",
}

export enum RechargeStatus {
  Paying = 1, // 正在支付
  Paid = 2, // 支付成功
  Cancelled = 3, // 取消支付
  Failed = 4, // 支付失败
  Refunded = 5, // 退款
  PendingReceiptConfirmation = 6, // 待确认收款
  Received = 7, // 已收款
}

export enum RechargeInvoiceStatus {
  NotAvailable = 1,
  CanInvoice,
  Issued,
}
